var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1689 4.54585C3.39671 4.31805 3.76605 4.31805 3.99386 4.54585L7.66471 8.21671L11.3356 4.54585C11.5634 4.31805 11.9327 4.31805 12.1605 4.54585C12.3883 4.77366 12.3883 5.14301 12.1605 5.37081L8.07719 9.45415C7.84939 9.68195 7.48004 9.68195 7.25223 9.45415L3.1689 5.37081C2.9411 5.14301 2.9411 4.77366 3.1689 4.54585Z",
    fill: "#4A5467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevDown);
export default __webpack_public_path__ + "static/media/ic-chev-down.44dc48af72cd2f93aabf241a85584917.svg";
export { ForwardRef as ReactComponent };